import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

// Auth Services
import { AuthenticationService } from '../services/auth.service';
import { AuthfakeauthenticationService } from '../services/authfake.service';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard  {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private authFackservice: AuthfakeauthenticationService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (environment.defaultauth === 'firebase') {
            const currentUser = this.authenticationService.currentUser();
            if (currentUser) {
                // logged in so return true
                return true;
            }
            // Firebase's auth state resolves asynchronously; fall back to the
            // synchronously-available cached session so a page refresh doesn't
            // bounce an already-logged-in user back to signin.
            if (localStorage.getItem('currentUser')) {
                return true;
            }
        } else {
            const currentUser = this.authFackservice.currentUserValue;
            if (currentUser) {
                // logged in so return true
                return true;
            }
            // check if user data is in storage is logged in via API.
            if(localStorage.getItem('currentUser')) {
                return true;
            }
        }
        // No logueado: la raíz del sitio muestra la landing pública; cualquier
        // otra ruta protegida manda a signin conservando el returnUrl para
        // volver ahí después de iniciar sesión.
        if (state.url === '/') {
            this.router.navigate(['/landing']);
        } else {
            this.router.navigate(['/auth/signin'], { queryParams: { returnUrl: state.url } });
        }
        return false;
    }
}
